export const TEXTS = {
    COMING_SOON: 'Coming soon',
    CONNECTED: 'Connected ✓',
    ERROR_MESSAGE: "Sorry, we couldn't find a Google Ads Account in this account",
    SIGN_IN_INTEGRATION: 'Head to their App Store',
    INTEGRATE_NOW: 'Connect now ➙',
    UPGRADE_PLAN: 'Upgrade plan to integrate',
    OPEN_ASSOCIATE_ACCOUNTS_MODAL: 'Integration succeeded, now link your accounts to start using Pareto Ads',
    FINAL_TITLE: 'Integration',
    MAINTENANCE: 'Under maintenance',
    INTEGRATION_SUCCESS_WITHOUT_MODAL: 'Integration succeedeed',
};

export const ROUTES = {
    LIST: '/settings/integrations',
    OAUTH_CALLBACK: '/settings/integrations/callback/oauth/:providerId',
};

export const IMAGES = {
    MODAL_BACKGROUND: {
        SRC: '/static/img/modal-integrations-background.png',
    },
};


export const ICON_SIZE = 24;
